exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Form {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n}\r\n\r\n.Form > label {\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\tdisplay: block;\r\n\tcolor: #AAA;\r\n\tfont-family: Roboto;\r\n\tfont-weight: 300;\r\n\tfont-size: 16px;\r\n}\r\n\r\n.Form > .Input, .Form > .InputWithUnit, .Form > .Select, .Form > .TextArea {\r\n\twidth: 100%;\r\n\tmargin: 5px 0px 10px 0px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/vwa/components/Form/Form.css
// module id = 687
// module chunks = 0